import React, { useMemo } from 'react';
import { formatStatus } from '../constants/workflowLabels';

function countByStatus(rows = []) {
  const counts = {};
  rows.forEach((r) => {
    const s = r.status || 'intake';
    counts[s] = (counts[s] || 0) + 1;
  });
  return counts;
}

const StatusBreakdownChart = ({ title, rows = [] }) => {
  const counts = useMemo(() => countByStatus(rows), [rows]);
  const entries = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  const max = entries.length ? Math.max(...entries.map(([, n]) => n)) : 1;

  if (!entries.length) {
    return (
      <div className="rhs-status-chart">
        <h4 className="rhs-card-title">{title}</h4>
        <p className="rhs-muted text-sm">No records yet.</p>
      </div>
    );
  }

  return (
    <div className="rhs-status-chart">
      <h4 className="rhs-card-title">{title}</h4>
      <ul className="rhs-status-chart-list">
        {entries.map(([status, count]) => (
          <li key={status} className={`rhs-status-chart-row rhs-status-chart-row--${status}`}>
            <span className="rhs-status-chart-label">{formatStatus(status)}</span>
            <span className="rhs-status-chart-bar-wrap" aria-hidden="true">
              <span
                className="rhs-status-chart-bar"
                style={{ width: `${Math.round((count / max) * 100)}%` }}
              />
            </span>
            <span className="rhs-status-chart-count">{count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StatusBreakdownChart;
